/**
 * Walks BIOES labels left to right, emitting one PII span per contiguous
 * tagged region. Direct port of `SpanAssembler.kt`. Special tokens (CLS,
 * SEP, PAD, etc.) are skipped when their offset window is empty
 * (`start === end`) — that's the convention transformers.js's tokenizer
 * uses to mark synthetic tokens.
 */

import type { PiiSpan } from "./pii.js";

export interface CharSpan {
  start: number;
  end: number;
}

export function assembleSpans(
  labels: readonly string[],
  offsets: readonly CharSpan[],
  attentionMask: readonly number[],
): PiiSpan[] {
  const out: PiiSpan[] = [];
  let openLabel: string | null = null;
  let openStart = -1;
  let openEnd = -1;

  const closeOpen = () => {
    if (openLabel !== null && openStart >= 0 && openEnd > openStart) {
      out.push({ start: openStart, endExclusive: openEnd, label: openLabel });
    }
    openLabel = null;
    openStart = -1;
    openEnd = -1;
  };

  for (let i = 0; i < labels.length; i++) {
    if (i >= attentionMask.length || attentionMask[i] === 0) continue;
    const offset = offsets[i];
    if (!offset || offset.end <= offset.start) continue;
    const tag = labels[i];
    const dash = tag.indexOf("-");
    const prefix = tag === "O" ? "O" : dash >= 0 ? tag.substring(0, dash) : tag;
    const cls = tag === "O" ? "" : dash >= 0 ? tag.substring(dash + 1) : "";

    switch (prefix) {
      case "B":
        closeOpen();
        openLabel = cls;
        openStart = offset.start;
        openEnd = offset.end;
        break;
      case "I":
        if (openLabel === cls) {
          openEnd = offset.end;
        } else {
          closeOpen();
          openLabel = cls;
          openStart = offset.start;
          openEnd = offset.end;
        }
        break;
      case "E":
        if (openLabel === cls) {
          openEnd = offset.end;
          closeOpen();
        } else {
          closeOpen();
          out.push({ start: offset.start, endExclusive: offset.end, label: cls });
        }
        break;
      case "S":
        closeOpen();
        out.push({ start: offset.start, endExclusive: offset.end, label: cls });
        break;
      default:
        closeOpen();
    }
  }
  closeOpen();
  return out;
}
